(() => {
  const root = document.getElementById('PredictiveSearch');
  if (!root) return;
  const input = document.getElementById('PredictiveSearchInput');
  const results = document.getElementById('PredictiveResults');
  const backdrop = root.querySelector('.predictive-search__backdrop');
  const panel = root.querySelector('.predictive-search__panel');

  const open = () => {
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    input.focus();
    trapFocus(panel);
  };
  const close = () => {
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    results.innerHTML = '';
    releaseFocus(panel);
  };

  const trigger = document.querySelector('[data-open-search]');
  if (trigger) trigger.addEventListener('click', open);
  if (backdrop) backdrop.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.getAttribute('aria-hidden') === 'false') close();
  });

  let controller;
  let lastReq = 0;
  input.addEventListener('input', async (e) => {
    const q = e.target.value.trim();
    if (controller) controller.abort();
    controller = new AbortController();
    const reqId = ++lastReq;
    if (!q) { results.innerHTML = ''; return; }
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article,page,collection&resources[limit]=6`;
      const res = await fetch(url, { signal: controller.signal });
      const data = await res.json();
      if (reqId !== lastReq) return; // drop stale
      results.innerHTML = renderResults(data, q);
      results.querySelectorAll('.predictive-search__item').forEach((el) => {
        el.addEventListener('keydown', (ev) => {
          if (ev.key === 'ArrowDown') moveFocus(el, 1);
          if (ev.key === 'ArrowUp') moveFocus(el, -1);
        });
      });
    } catch (err) { /* silent fail */ }
  });

  function renderResults(data, query) {
    const highlight = (text) => text.replace(new RegExp(`(${escapeRegExp(query)})`, 'gi'), '<mark>$1</mark>');
    const truncate = (str, n) => (str && str.length > n) ? str.slice(0, n - 1) + '…' : (str || '');

    const blocks = [];
    const prods = (data?.resources?.results?.products || []).map(p => `
      <a class="predictive-search__item" href="${p.url}" role="option">
        ${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}
        <div>
          <strong>${highlight(p.title)}</strong>
          ${p.price ? `<span class="predictive-search__price">${p.price}</span>` : ''}
        </div>
      </a>
    `).join('');
    if (prods) blocks.push(`<h4 class="predictive-search__heading">Products</h4>${prods}`);

    const cols = (data?.resources?.results?.collections || []).map(c => `
      <a class="predictive-search__item" href="${c.url}" role="option">
        <div><strong>${highlight(c.title)}</strong></div>
      </a>
    `).join('');
    if (cols) blocks.push(`<h4 class="predictive-search__heading">Collections</h4>${cols}`);

    const arts = (data?.resources?.results?.articles || []).map(a => `
      <a class="predictive-search__item" href="${a.url}" role="option">
        <div>
          <strong>${highlight(a.title)}</strong>
          ${a.body ? `<p class="predictive-search__excerpt">${truncate(a.body, 90)}</p>` : ''}
        </div>
      </a>
    `).join('');
    if (arts) blocks.push(`<h4 class="predictive-search__heading">Articles</h4>${arts}`);

    const pages = (data?.resources?.results?.pages || []).map(p => `
      <a class="predictive-search__item" href="${p.url}" role="option">
        <div><strong>${highlight(p.title)}</strong></div>
      </a>
    `).join('');
    if (pages) blocks.push(`<h4 class="predictive-search__heading">Pages</h4>${pages}`);

    return blocks.join('') || `<p class="predictive-search__empty">${window.PREDICTIVE_EMPTY || 'No results found'}</p>`;
  }

  function escapeRegExp(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function moveFocus(current, delta) {
    const items = Array.from(results.querySelectorAll('.predictive-search__item'));
    const i = items.indexOf(current);
    const next = items[i + delta] || items[(delta > 0) ? 0 : items.length - 1];
    next && next.focus();
  }

  // Simple focus trap
  function trapFocus(container) {
    const focusable = container.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    function handle(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handle);
    container.__trap__ = handle;
  }
  function releaseFocus(container) {
    if (container.__trap__) container.removeEventListener('keydown', container.__trap__);
  }
})();
